import { Link, Box, Flex, Text, Image, Stack } from "@chakra-ui/react"
import {Link as RouterLink} from 'react-router-dom'
import doubleQuoteImg from './cite-double-quote.png'

const sectionData = [
  {
    id: 1,
    text: "Gdyby Tim Krabbé pisał tę książkę z miernikiem mocy, to wartości byłyby bardzo wysokie ;) Ogień od startu, mnóstwo ciekawostek i kawał kolarskiej historii. Po prostu klasyk! A może nawet Monument…",
    author: "Adam Probosz, Eurosport, TurDeTur",
    imageUrl: '/images/tdt-logo-logotyp.webp'
  },

]

const Cite = ({ text, author, imageUrl }: { text: string; author: string; imageUrl?: string }) => {
  return (
    <Stack p={2} m={'auto'} direction={{base: 'column', md: 'row'}} spacing={16}>
      <Box bgImage={doubleQuoteImg} bgRepeat={'no-repeat'} flexBasis={'60%'}>
        <Text fontSize={{base: 'md', md: 'lg'}} pl={20}>
          {text}
        </Text>
        <Text textAlign={'right'} fontWeight={'bold'} mt={2}>
          ~ {author}
        </Text>
      </Box>
      <Box justifyItems={'center'} flexBasis={'40%'}>
      <Text  fontSize={{base: 'sm', md: 'md'}}>Patronat medialny:</Text>
      <Link as={RouterLink} to="https://www.facebook.com/TurDeTurTV" isExternal>
        <Image  p={4} bgColor={'white'} borderRadius={4} my={4} src={imageUrl} alt="TurDeTur - logo" mx="auto" w={{ base: '200px', md: '300px' }} />
      </Link>
      </Box>
    </Stack>
  )
}

export const CiteSection = () => {
  return (
    <Flex
      width="100%"
      alignContent="center"
      justifyItems={'center'}
      direction={{ base: "row" }}
      alignItems={"stretch"}
      flexFlow={"wrap"}
    >
      {sectionData.map(cite => <Cite key={cite.id} text={cite.text} author={cite.author} imageUrl={cite.imageUrl} />)}
    </Flex>
  )
}